import { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";

export default function AudioPlayer({ src }) {
  const audioRef = useRef();
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  if (!src) return null;

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) a.pause();
    else a.play();
    setPlaying(!playing);
  };

  const onTime = () => {
    const a = audioRef.current;
    if (a?.duration) setProgress((a.currentTime / a.duration) * 100);
  };

  const seek = (e) => {
    const a = audioRef.current;
    const rect = e.currentTarget.getBoundingClientRect();
    const pct = (e.clientX - rect.left) / rect.width;
    if (a?.duration) a.currentTime = pct * a.duration;
  };

  return (
    <div className="flex items-center gap-4 bg-secondary/60 rounded-2xl p-4" data-testid="audio-player">
      <button onClick={toggle} className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center shrink-0 hover:bg-primary/90 transition-colors" data-testid="audio-play-btn">
        {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
      </button>
      <div className="flex-1 h-2 bg-background rounded-full cursor-pointer" onClick={seek}>
        <div className="h-full bg-primary rounded-full transition-[width] duration-200" style={{ width: `${progress}%` }} />
      </div>
      <audio ref={audioRef} src={src} onTimeUpdate={onTime} onEnded={() => setPlaying(false)} className="hidden" />
    </div>
  );
}
